import type { LeadCreateDataType } from '@econtractor/types';

export const initNewLeadStruct: LeadCreateDataType = {
    clientId: 0,
    clientName: '',
    clientEmail: '',
    clientPhone: '',
    clientAddress: '',
    clientLocation: '',
    eventInfo: '',
    leadName: '',
};
